// Action creators
import { readJson } from './apiResponse';

// fetch data from an API
// fetch call gets returned from an outer function & outer function has dispatch as a param
// if want to access the state inside the action creator, can add getState in the param's list
var fetchMembers = () => {
  return function (dispatch) {
    // api/user/list requires auth now. MemberList mounts behind the login
    // overlay, so this runs while logged out - skip rather than trying to
    // parse the empty body of a 401.
    if (!localStorage.token) {
      return Promise.resolve();
    }
    return fetch('api/user/list', {
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${localStorage.token}`
      }
    })
      .then(results => readJson(results, 'api/user/list'))
        .then(json => {
            if (!json) {
              return;
            }
            json.sort(function (a, b) {
                var nameA = a.firstName.toLowerCase(), nameB = b.firstName.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0;
            });
            dispatch({ type: "DATA_LOADED", payload: json }); //need to call dispatch inside the async function for dispatching the action
        // dispatch({ type: "DATA_LOADED", payload: json })
      })
      .catch(err => console.error('fetchMembers failed:', err));
  };
}

export default { 'FETCH_MEMBERS': fetchMembers };


// WEBPACK FOOTER //
// ./src/actions/member_actions.js